import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import cashiersTable from '../../tables/cashiers';
import Table from '../../components/Table';
import Guide from '../../components/Guide';
import Modal from '../../components/Modal';
import cashierFields from '../../forms/cashiers/create';
import modalInfo from '../../helpers/CashierInfo';
import modalActions from '../../actions/modal';
import formHelpers from '../../helpers/FormHelpers';
import populateForm from '../../helpers/PopulateForm';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import Button from '../../components/Button';
import cashierActions from '../../actions/cashier';
import credentialHelpers from '../../helpers/Credentials';

class Cashiers extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleCashierFinish = this.handleCashierFinish.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleCashierEditClick = this.handleCashierEditClick.bind(this);
    this.resetFields = this.resetFields.bind(this);
  }

  componentWillMount() {
    const { dispatch, vendor, location } = this.props;
    if (vendor.selected && vendor.selected.apikey &&
      location.selected && location.selected.apikey) {
      dispatch(cashierActions.list(vendor.selected.apikey, location.selected.apikey));
    }
    this.setState({
      fields: cashierFields,
      updateField: false
    })
  }

  resetFields() {
    this.setState({
      fields: cashierFields,
      updateField: false
    });
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

	handleModalToggle() {
    const { dispatch, modal } = this.props;
    this.resetFields();
    dispatch(modalActions.modalToggle(!modal.showModal));
	}

	handleCashierFinish() {
    const { fields, updateField } = this.state;
    const { dispatch, vendor, location } = this.props;
    let data = extractPhasesOrFail({ fields });
    let hasCreds = credentialHelpers.hasVendorAndLocation(this.props);

    if (data && updateField) {
      dispatch(cashierActions.update(
        data, vendor.selected.apikey, location.selected.apikey, updateField.apikey
      ));
    } else if (data && hasCreds) {
      dispatch(cashierActions.create(
        data, vendor.selected.apikey, location.selected.apikey
      ));
    } else {
      this.setState({
        fields: formHelpers.blurphase(fields)
      })
    }
  }

  handleNewClick() {
    this.resetFields();
    this.handleModalToggle();
  }

  handleCashierEditClick(row) {
    this.props.dispatch(modalActions.modalToggle(true));
    this.setState({
      updateField: row,
      fields: populateForm(row, cashierFields)
    })
  }

  render() {
    return (
      <div>
				<Header
          handleLogout={this.props.handleLogoutClick}
					handlePrimaryClick={this.handleNewClick}
					primaryText="NEW CASHIER"
					title="CASHIERS" />
				<Table
          handleEditClick={this.handleCashierEditClick}
					rows={this.props.cashier.data}
					columns={cashiersTable} />
				{
					this.props.modal.showModal &&
					<Modal
						handleCloseClick={this.handleModalToggle}
						title={modalInfo.title}>
						<div className="signup__guide">
							<Guide
								header={modalInfo.subTitle}
								message={modalInfo.content}
								/>
						</div>
						<div className="signup__form">
							<div>
								{ formHelpers.buildFields(this.state.fields, this) }
							</div>
							<Button
								allowHover={true}
								text="Finish"
								onClick={this.handleCashierFinish}/>
						</div>

					</Modal>
				}
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    vendor: state.vendor,
    location: state.location,
    cashier: state.cashier,
    modal: state.modal
  })
)(Cashiers));



/** WEBPACK FOOTER **
 ** ./src/containers/Cashiers/index.js
 **/